import { useMemo } from 'react';
import { useAuth } from './useAuth';

/**
 * Åtkomst till säljpresentationen (/uppfoljning) — styrs av env-varen
 * VITE_PRESENTATION_EMAILS (kommaseparerad lista).
 *
 * OBS: detta är BARA en visuell gating, precis som useAdmin. Sidan har inget
 * backend-anrop och innehåller inga priser eller hemligheter — allt innehåll
 * ligger i JS-bundlen och kan i teorin läsas av vem som helst som gräver i
 * den. Lägg därför aldrig in prisuppgifter, marginaler eller intern strategi
 * här; sidan är formulerad för kundens ögon.
 *
 * Sätts inte env-varen syns fliken för ingen — medvetet val: hellre osynlig
 * än synlig för fel person.
 */
export function useSalesPreview() {
  const { user, loading } = useAuth();

  const canSee = useMemo(() => {
    if (!user?.email) return false;
    const raw = import.meta.env.VITE_PRESENTATION_EMAILS ?? '';
    const list = raw
      .split(',')
      .map((s: string) => s.trim().toLowerCase())
      .filter(Boolean);
    return list.includes(user.email.toLowerCase());
  }, [user?.email]);

  return { canSee, loading };
}
